import { ChangeEventHandler } from 'react';
import './Checkbox.css';

type CheckboxProps = {
	id: string;
	className?: string;
	label: string;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	checked?: boolean;
};

const Checkbox = ({ className, id, label, checked, onChange }: CheckboxProps): JSX.Element => {
	return (
		<div className={`checkbox ${className || ''}`}>
			<label className="form-control" htmlFor={id}>
				<input id={id} type="checkbox" checked={checked} onChange={onChange} />
				{label}
			</label>
		</div>
	);
};

export default Checkbox;
